import { Center, Stack } from "@mantine/core"
import { Chat } from "../../../../../-components/chat"
import { ChatListForCurrentUser } from "../../../../../-components/chat/ChatListForCurrentUser"
import { Page } from "../../../../../../-components/Page"
import { SuspenseWithErrorBoundary } from "../../../../../../-components/suspense"
import { useBreakpoints } from "../../../../../../utils/use-breakpoints"
import { useTranslation } from "react-i18next"
import { ChatHeaderGroup } from "../../../../../-components/chat/ChatHeaderGroup"
import { PageLayoutGroup33_66 } from "../../../../../../-components/Page/PageLayoutGroup33_66"

interface Props {
  chatId?: number | undefined
}

export function ChatPage({ chatId }: Props) {
  const { t } = useTranslation("app_server")

  const { xs, sm, md } = useBreakpoints()

  const smallLayout = xs || sm || md

  const rightPanelContent = (
    <SuspenseWithErrorBoundary>
      {chatId ? (
        <Chat chatId={chatId} />
      ) : (
        <Center w="100%">{t("NoChatSelected")}</Center>
      )}
    </SuspenseWithErrorBoundary>
  )

  const leftPanelContent = (
    <ChatListForCurrentUser smallLayout={!!smallLayout} />
  )

  return (
    <Page
      crumbOverride={
        chatId && smallLayout
          ? () => <ChatHeaderGroup chatId={chatId} />
          : undefined
      }
      navGroupProps={{
        wrap: "nowrap",
        w: "100%",
        style: { overflow: "hidden" },
      }}
    >
      {smallLayout ? (
        chatId === undefined ? (
          <Stack h="100%" gap="xs">
            {leftPanelContent}
          </Stack>
        ) : (
          rightPanelContent
        )
      ) : (
        <PageLayoutGroup33_66
          leftPanelContent={leftPanelContent}
          rightPanelContent={rightPanelContent}
        />
      )}
    </Page>
  )
}
